import { useEffect } from "react";
import Lenis from "lenis";
import { MessageCircle } from "lucide-react";
import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import EditorialMarquee from "./components/site/Marquee";
import About from "./components/site/About";
import Services from "./components/site/Services";
import Experience from "./components/site/Experience";
import WhyUs from "./components/site/WhyUs";
import Reviews from "./components/site/Reviews";
import CTASection from "./components/site/CTASection";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";
import { WA_BOOK } from "./lib/site";
import "./App.css";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            window.__lenis = undefined;
        };
    }, []);

    return (
        <div className="min-h-screen bg-emerald-950 text-cream">
            <div className="grain-overlay" aria-hidden="true" />
            <Header />
            <main>
                <Hero />
                <EditorialMarquee />
                <About />
                <Services />
                <Experience />
                <WhyUs />
                <Reviews />
                <CTASection />
                <Contact />
            </main>
            <Footer />
            <a
                href={WA_BOOK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-float"
                aria-label="Chat with Flammingo Luxurious Spa on WhatsApp"
                className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-gold text-emerald-950 shadow-[0_8px_30px_rgba(212,175,55,0.35)] transition-all duration-300 hover:scale-105 hover:bg-gold-light"
            >
                <MessageCircle size={24} aria-hidden="true" />
            </a>
        </div>
    );
}

export default App;
